function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Alert, Button, Modal, Space, notification, Statistic, InputNumber, Drawer } from "antd";
import { Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import OrderReceipt from "../OrderReceipt";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AddCustomerSettlement = function AddCustomerSettlement(_ref) {
  var handler = _ref.handler,
    _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? null : _ref$bill;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var ref = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showReceipt = _useState8[0],
    setShowReceipt = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    amount = _useState10[0],
    setAmount = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    itemsList = _useState12[0],
    setItemsList = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    settlement = _useState14[0],
    setSettlement = _useState14[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var exec = function exec(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    setAmount(values.amount);
    var formData = new FormData();
    formData.append('amount', values.amount);
    formData.append('bill_id', bill.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addsettlement', formData).then(function (response) {
      if (response.data.status == 200) {
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
        setSettlement(response.data.settlement);
        setShowReceipt(true);
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    setFormError("");
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ? "
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'encaissement de ", values.amount.toLocaleString("Fr"), " ?"]
      }),
      onOk: function onOk() {
        exec(values);
      },
      onCancel: function onCancel() {
        setIsFormLoading(false);
      }
    });
  };
  useEffect(function () {
    bill.bill_items.forEach(function (e) {
      setItemsList(function (prev) {
        return [].concat(_toConsumableArray(prev), [e.label]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        sm: 6,
        children: /*#__PURE__*/_jsx(Statistic, {
          value: bill.total_amount,
          title: /*#__PURE__*/_jsx("b", {
            children: "Montant Total"
          }),
          decimalSeparator: " "
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        sm: 6,
        children: /*#__PURE__*/_jsx(Statistic, {
          value: bill.total_amount - bill.paid_amount,
          title: /*#__PURE__*/_jsx("b", {
            children: "Reste \xE0 payer"
          }),
          decimalSeparator: " "
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          banner: true,
          message: formError
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        wrap: true,
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "amount",
          label: "Montant",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(InputNumber, {
            formatter: function formatter(value) {
              return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            },
            style: {
              width: "150px"
            }
          })
        }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
          label: " ",
          children: /*#__PURE__*/_jsx(Button, {
            htmlType: "submit",
            icon: /*#__PURE__*/_jsx(CheckCircleFill, {}),
            disabled: bill == null,
            loading: isFormLoading,
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Valider"
            })
          })
        })]
      })]
    }), showReceipt && bill && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
        handler();
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "Imprimer"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/_jsx(OrderReceipt, {
          bill: bill,
          settlement: settlement
        })
      })
    })]
  });
};
export default AddCustomerSettlement;